;(function( window, document, bq ){ window.jQuery(function($) { 'use strict';

bq.itemRecommendations = function(element, options) {
    this.$el = $(element);
    this.options = options;
    this._supplierId = options.supplierId || '';
    this._sku = options.sku || '';
    this._isLoadingInitialState = false;
    this._hadGlobalActive = false;
    this._initialActiveGroups = [];
    this._initialInactiveGroups = [];
};

bq.itemRecommendations.DEFAULTS = {
    logUrl: '',
    writeGroupsForProductUrl: '',
    readGroupsByProductUrl: '',
    instanceId: '',
    supplierId: '',
    sku: '',
    labels: {
        saving: 'Saving...',
        save: 'Save',
        savingRecommendations: 'Saving recommendations...',
        saveSuccess: 'Product recommended successfully!',
        saveFailed: 'Failed to save recommendations.',
        someBatchesFailed: 'Some batches failed. ',
        succeeded: ' succeeded',
        noChanges: 'No changes to save.'
    }
};

bq.itemRecommendations.prototype = {
    init: function() {
        this._applyOpenRecommendContext();
        this._bindEvents();
        this._observeAndInit();
    },

    _applyOpenRecommendContext: function() {
        if (typeof window.bqOpenRecommendFor !== 'undefined' && window.bqOpenRecommendFor) {
            this._supplierId = window.bqOpenRecommendFor.supplier_id || this._supplierId;
            this._sku = window.bqOpenRecommendFor.sku || this._sku;

            var self = this;
            setTimeout(function() {
                var modalId = self.$el.data('modal-id');
                var $saveBtn = $('#' + modalId + '-save');
                if ($saveBtn.length) {
                    $saveBtn.attr('data-supplier-id', self._supplierId);
                    $saveBtn.attr('data-sku', self._sku);
                }
                if (window.bqOpenRecommendFor && window.bqOpenRecommendFor.name) {
                    $('#' + modalId + '-product-name').text(window.bqOpenRecommendFor.name);
                }
            }, 50);

            delete window.bqOpenRecommendFor;
        }
    },

    _modalId: function() {
        return this.$el.data('modal-id');
    },

    _initForm: function() {
        var modalId = this._modalId();
        this._$saveBtn = $('#' + modalId + '-save');
        this._$status = $('#' + modalId + '-status');
        this._$recommendAll = $('#' + modalId + '-recommend-all');
        this._$contentGroupsContainer = $('#' + modalId + '-content-groups-container');
        this._$contentGroupCheckboxes = this.$el.find('.content-group-checkbox');
        this._$toggleAll = $('#' + modalId + '-toggle-all');
    },

    _setContentGroupsEnabled: function(isEnabled) {
        this._$contentGroupCheckboxes.prop('disabled', !isEnabled);
        this._$contentGroupsContainer.css({
            'opacity': isEnabled ? '1' : '0.5',
            'pointer-events': isEnabled ? 'auto' : 'none'
        });
        if (isEnabled) {
            this._$toggleAll.show();
        } else {
            this._$toggleAll.hide();
        }
    },

    _syncRecommendControls: function() {
        if (this._$recommendAll.is(':checked')) {
            this._setContentGroupsEnabled(false);
            return;
        }
        this._setContentGroupsEnabled(true);
        this._$recommendAll.prop('disabled', false);
    },

    _loadExistingRecommendations: function() {
        if (this._isLoadingInitialState) { return; }
        this._isLoadingInitialState = true;

        var self = this;
        var allGroupIds = [];
        this._$contentGroupCheckboxes.each(function() {
            allGroupIds.push($(this).val());
        });

        $.ajax({
            url: this.options.readGroupsByProductUrl,
            type: 'GET',
            dataType: 'json',
            data: { supplier_id: this._supplierId, sku: this._sku },
            timeout: 5000
        }).done(function(resp) {
            self._isLoadingInitialState = false;

            if (!resp || !resp.success || !resp.items || resp.items.length === 0) {
                self._syncRecommendControls();
                return;
            }

            var hasGlobalActive = false;
            var specificGroupsActive = [];
            var specificGroupsInactive = [];

            resp.items.forEach(function(item) {
                var isGlobal = !item.content_group_id || item.content_group_id === null || item.content_group_id === '';
                if (item.status === 'ACTIVE') {
                    if (isGlobal) { hasGlobalActive = true; } else { specificGroupsActive.push(item.content_group_id); }
                } else if (item.status === 'INACTIVE') {
                    if (!isGlobal) { specificGroupsInactive.push(item.content_group_id); }
                }
            });

            self._initialInactiveGroups = specificGroupsInactive.slice();

            if (hasGlobalActive && specificGroupsInactive.length === 0) {
                self._hadGlobalActive = true;
                if (specificGroupsActive.length > 0) {
                    self._initialActiveGroups = specificGroupsActive.slice();
                    specificGroupsActive.forEach(function(groupId) {
                        self.$el.find('.content-group-checkbox[value="' + groupId + '"]').prop('checked', true);
                    });
                }
                self._$recommendAll.prop('checked', true);
                self._syncRecommendControls();
                return;
            }

            if (specificGroupsActive.length > 0 && !hasGlobalActive) {
                self._initialActiveGroups = specificGroupsActive.slice();
                self._$recommendAll.prop('checked', false);
                specificGroupsActive.forEach(function(groupId) {
                    self.$el.find('.content-group-checkbox[value="' + groupId + '"]').prop('checked', true);
                });
                self._syncRecommendControls();
            } else if (hasGlobalActive && specificGroupsInactive.length > 0) {
                self._$recommendAll.prop('checked', false);
                var activeGroups = [];
                allGroupIds.forEach(function(groupId) {
                    if (specificGroupsInactive.indexOf(groupId) === -1) {
                        activeGroups.push(groupId);
                        self.$el.find('.content-group-checkbox[value="' + groupId + '"]').prop('checked', true);
                    }
                });
                self._initialActiveGroups = activeGroups.slice();
                self._syncRecommendControls();
            }
        }).fail(function() {
            self._isLoadingInitialState = false;
            self._syncRecommendControls();
        });
    },

    _chunkArray: function(array, size) {
        var chunks = [];
        for (var i = 0; i < array.length; i += size) {
            chunks.push(array.slice(i, i + size));
        }
        return chunks;
    },

    _sendBatchCalls: function(supplierId, sku, groups, callback) {
        if (groups.length === 0) { callback(0, 0); return; }
        $.ajax({
            url: this.options.writeGroupsForProductUrl,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({ supplier_id: String(supplierId), sku: String(sku), items: groups })
        }).done(function(resp) {
            if (!resp || !resp.success) { callback(0, 1); } else { callback(1, 0); }
        }).fail(function() {
            callback(0, 1);
        });
    },

    _bindEvents: function() {
        var self = this;
        var modalId = this._modalId();
        var labels = bq.messages.recommendations;

        $(document).off('change.itemRecommendations', '#' + modalId + '-recommend-all')
            .on('change.itemRecommendations', '#' + modalId + '-recommend-all', function() {
                if (self._isLoadingInitialState) { return; }
                self._syncRecommendControls();
            });

        $(document).off('change.itemRecommendations', '.content-group-checkbox')
            .on('change.itemRecommendations', '.content-group-checkbox', function() {
                if (self._isLoadingInitialState) { return; }
                self._syncRecommendControls();
            });

        $(document).off('click.itemRecommendations', '#' + modalId + '-toggle-all')
            .on('click.itemRecommendations', '#' + modalId + '-toggle-all', function(e) {
                e.preventDefault();
                var allChecked = true;
                self._$contentGroupCheckboxes.each(function() {
                    if (!$(this).is(':checked')) { allChecked = false; return false; }
                });
                self._$contentGroupCheckboxes.prop('checked', !allChecked);
            });

        $(document).off('click.itemRecommendationsCancel', '.recommend-modal-cancel')
            .on('click.itemRecommendationsCancel', '.recommend-modal-cancel', function(e) {
                e.preventDefault();
                $(this).closest('.modal').modal('hide');
            });

        $(document).off('click.itemRecommendationsSave', '#' + modalId + '-save')
            .on('click.itemRecommendationsSave', '#' + modalId + '-save', function() {
                self._handleSave();
            });

        $(document).on('hidden.bs.modal', function(e) {
            if ($(e.target).find('[data-modal-id="' + modalId + '"]').length > 0) {
                self._reset();
            }
        });

        $(document).on('recommendFormInserted', function() {
            setTimeout(function() {
                if ($('[data-modal-id="' + modalId + '"]').length === 0) { return; }
                self._initForm();
                if (typeof window.bqOpenRecommendFor !== 'undefined' && window.bqOpenRecommendFor) {
                    self._supplierId = window.bqOpenRecommendFor.supplier_id || self._supplierId;
                    self._sku = window.bqOpenRecommendFor.sku || self._sku;
                    var $saveBtn = $('#' + modalId + '-save');
                    if ($saveBtn.length) {
                        $saveBtn.attr('data-supplier-id', self._supplierId);
                        $saveBtn.attr('data-sku', self._sku);
                    }
                    if (window.bqOpenRecommendFor.name) {
                        $('#' + modalId + '-product-name').text(window.bqOpenRecommendFor.name);
                    }
                    delete window.bqOpenRecommendFor;
                }
                self._loadExistingRecommendations();
            }, 100);
        });
    },

    _observeAndInit: function() {
        var self = this;
        var modalId = this._modalId();

        if ($('[data-modal-id="' + modalId + '"]').length > 0) {
            setTimeout(function() {
                self._initForm();
                self._syncRecommendControls();
                self._loadExistingRecommendations();
            }, 100);
        } else {
            var observer = new MutationObserver(function() {
                if ($('[data-modal-id="' + modalId + '"]').length > 0) {
                    observer.disconnect();
                    setTimeout(function() {
                        self._initForm();
                        self._syncRecommendControls();
                        self._loadExistingRecommendations();
                    }, 100);
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    },

    _handleSave: function() {
        var self = this;
        var labels = bq.messages.recommendations;
        var isRecommendAll = this._$recommendAll.is(':checked');
        var $checkedBoxes = this.$el.find('.content-group-checkbox:checked');
        var supplierId = this._$saveBtn.data('supplier-id') || this._supplierId;
        var sku = this._$saveBtn.data('sku') || this._sku;

        this._$saveBtn.prop('disabled', true).text(labels.saving);
        this._$status.removeClass('alert-success alert-danger alert-warning').addClass('alert-info')
            .text(labels.savingRecommendations).show();

        var groups = [];

        if (isRecommendAll) {
            groups.push({ status: 'ACTIVE' });
            this._initialInactiveGroups.forEach(function(contentGroupId) {
                groups.push({ status: 'ACTIVE', content_group_id: contentGroupId });
            });
        } else {
            var currentlyChecked = [];
            $checkedBoxes.each(function() { currentlyChecked.push($(this).val()); });

            var groupsToEnable = currentlyChecked.filter(function(g) { return self._initialActiveGroups.indexOf(g) === -1; });
            var groupsToDisable = self._initialActiveGroups.filter(function(g) { return currentlyChecked.indexOf(g) === -1; });

            if (this._hadGlobalActive) {
                groups.push({ status: 'INACTIVE' });
            }
            groupsToDisable.forEach(function(g) {
                groups.push({ status: 'INACTIVE', content_group_id: g });
            });
            groupsToEnable.forEach(function(g) {
                groups.push({ status: 'ACTIVE', content_group_id: g });
            });

            if (groups.length === 0) {
                this._$saveBtn.prop('disabled', false).text(labels.save);
                this._$status.removeClass('alert-info').addClass('alert-warning').text(labels.noChangesToSave);
                return;
            }
        }

        this._sendBatchCalls(supplierId, sku, groups, function(successCount, failCount) {
            self._$saveBtn.prop('disabled', false).text(labels.save);
            if (failCount === 0) {
                self._$status.removeClass('alert-info alert-danger alert-warning').addClass('alert-success')
                    .text(labels.saveSuccess);
                setTimeout(function() {
                    self.$el.closest('.modal').modal('hide');
                }, 1500);
            } else if (successCount > 0) {
                self._$status.removeClass('alert-info alert-success alert-danger').addClass('alert-warning')
                    .text(labels.someBatchesFailed + successCount + '/' + (successCount + failCount) + labels.succeeded);
            } else {
                self._$status.removeClass('alert-info alert-success alert-warning').addClass('alert-danger')
                    .text(labels.saveFailed);
            }
        });
    },

    _reset: function() {
        var modalId = this._modalId();
        var $recommendAll = $('#' + modalId + '-recommend-all');
        $recommendAll.prop('checked', false).prop('disabled', false);
        this.$el.find('.content-group-checkbox').prop('checked', false);
        this._setContentGroupsEnabled(true);
        var $toggleAll = $('#' + modalId + '-toggle-all');
        if ($toggleAll.length) { $toggleAll.show(); }
        var $status = $('#' + modalId + '-status');
        if ($status.length) { $status.hide(); }
        this._isLoadingInitialState = false;
        this._hadGlobalActive = false;
        this._initialActiveGroups = [];
        this._initialInactiveGroups = [];
    }
};

var oldItemRecommendations = $.fn.itemRecommendations;
$.fn.itemRecommendations = function(option) {
    return this.each(function() {
        var $this = $(this);
        var data = $this.data('bq.itemRecommendations');
        if (!data) {
            var options = $.extend(true, {}, bq.itemRecommendations.DEFAULTS, $this.data(), typeof option === 'object' && option);
            $this.data('bq.itemRecommendations', (data = new bq.itemRecommendations(this, options)));
            $this.attr('data-initialized', '1');
            data.init();
        }
    });
};
$.fn.itemRecommendations.Constructor = bq.itemRecommendations;
$.fn.itemRecommendations.noConflict = function() { $.fn.itemRecommendations = oldItemRecommendations; return this; };

bq.itemRecommendationsInit = function() {
    $('[data-bq="item-recommendations"]:not([data-initialized])').each(function() {
        $(this).itemRecommendations($(this).data());
    });
};
bq.init.push(bq.itemRecommendationsInit);
bq.itemRecommendationsInit();

});}( window, document, bq));
